import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Breadcrumbs } from '../ui/Breadcrumbs';
import { AppHeader } from './AppHeader';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="h-screen flex flex-col bg-background font-lato text-foreground">
      <AppHeader />
      <Breadcrumbs />
      <main className="flex-1 overflow-y-auto bg-muted/50">
        <div className="min-h-full flex flex-col">
          <div className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col">
            {children}
          </div>
          <footer className="border-t bg-background py-4">
            <div className="max-w-7xl mx-auto px-4 flex items-center justify-center gap-3 text-sm text-muted-foreground">
              <span>© {new Date().getFullYear()} Uniphore. All rights reserved.</span>
              <span aria-hidden className="text-muted-foreground/50">
                ·
              </span>
              <Link
                to="/status"
                className="hover:text-foreground hover:underline underline-offset-4"
              >
                Status
              </Link>
            </div>
          </footer>
        </div>
      </main>
    </div>
  );
}
